export default [
  { text: '', value: 'data-table-expand', default: true, defaultOnMobile: true },
  {
    text: 'stats.table.provider',
    value: 'logoProvider',
    default: true,
    defaultOnMobile: true,
    type: 'slot',
    align: 'left',
  },
  {
    text: 'stats.table.order',
    value: 'code',
    default: true,
    defaultOnMobile: true,
    align: 'left',
    type: 'slot',
  },
  {
    text: 'stats.table.status',
    value: 'status',
    default: true,
    defaultOnMobile: true,
    align: 'left',
    type: 'slot',
  },
  {
    text: 'stats.table.paymentMethod',
    value: 'method',
    default: true,
    defaultOnMobile: true,
    align: 'left',
    type: 'slot',
  },
  {
    text: 'stats.table.total',
    value: 'totalPrice',
    default: true,
    defaultOnMobile: true,
    align: 'left',
  },
  {
    text: 'stats.table.date',
    value: 'date',
    default: true,
    defaultOnMobile: true,
    type: 'slot',
    align: 'left',
  },
  {
    text: 'stats.table.checkoutIntegrationStatus',
    value: 'posStatus',
    type: 'slot',
    virtual: true,
    default: true,
    defaultOnMobile: true,
    align: 'left',
  },
  {
    text: 'stats.table.note',
    value: 'note',
    default: true,
    defaultOnMobile: true,
    type: 'slot',
    align: 'left',
  },
  {
    text: 'stats.table.time',
    value: 'time',
    default: true,
    defaultOnMobile: true,
    type: 'slot',
    align: 'left',
  },
  {
    text: 'stats.table.orderDate',
    value: 'orderDate',
    default: true,
    defaultOnMobile: true,
    type: 'slot',
    align: 'left',
  },
  {
    text: 'stats.table.orderTime',
    value: 'orderTime',
    default: true,
    defaultOnMobile: true,
    type: 'slot',
    align: 'left',
  },
  {
    text: 'stats.table.externalOrderId',
    value: 'externalOrderId',
    type: 'slot',
    align: 'left',
  },
  {
    text: 'stats.table.itemName',
    value: 'item_name',
    default: true,
    defaultOnMobile: true,
    type: 'slot',
    align: 'left',
  },
  {
    text: 'stats.table.loyaltyArticles',
    value: 'loyaltyArticles',
    type: 'slot',
    align: 'left',
  },
  {
    text: 'stats.table.dndCompanyCode',
    value: 'dndCompanyCode',
    align: 'left',
  },
  {
    text: 'stats.table.table',
    value: 'tableNumber',
    default: true,
    defaultOnMobile: true,
    align: 'left',
  },
  {
    text: 'stats.table.retry',
    value: 'retry',
    default: true,
    defaultOnMobile: true,
    type: 'slot',
    sortable: false,
  },
  {
    text: 'stats.table.customer',
    value: 'customer',
    default: true,
    defaultOnMobile: true,
    type: 'slot',
    align: 'left',
  },
  {
    text: 'stats.table.type',
    value: 'type',
    default: true,
    defaultOnMobile: true,
  },
  {
    text: 'stats.table.subType',
    value: 'subType',
    default: true,
    defaultOnMobile: true,
    type: 'slot',
    align: 'left',
  },
  {
    text: 'stats.table.secondaryCode',
    value: 'secondaryCode',
    default: true,
    defaultOnMobile: true,
    align: 'left',
  },
  {
    text: 'stats.table.clientMeta',
    value: 'clientMeta',
    type: 'slot',
    align: 'left',
  },
  {
    text: 'stats.table.room',
    value: 'room',
    type: 'slot',
    align: 'left',
  },
  {
    text: 'stats.table.promoCode',
    value: 'promoCode',
    default: true,
    defaultOnMobile: true,
    type: 'slot',
    align: 'left',
  },
  {
    text: 'stats.table.clientMeta',
    value: 'clientMeta',
    type: 'slot',
    align: 'left',
  },
  {
    text: 'stats.table.pickupStation',
    value: 'pickupStation',
    type: 'slot',
    align: 'left',
  },
];
